import { useQuery } from '@apollo/client';
import { useEntity } from '@avangard/utils/entity';

import { StudentOnlineApplicationEntity } from '@modules/students/entities';
import { GetStudentOnlineApplicationQuery } from '@modules/students/graphql';

import type { QueryHookOptions } from '@apollo/client';
import type {
    GetStudentOnlineApplicationQueryType,
    GetStudentOnlineApplicationQueryVariables,
} from '@modules/types/graphql';

const useStudentOnlineApplication = (
    options: QueryHookOptions<
        GetStudentOnlineApplicationQueryType,
        GetStudentOnlineApplicationQueryVariables
    > = {},
) => {
    const queryResult = useQuery<
        GetStudentOnlineApplicationQueryType,
        GetStudentOnlineApplicationQueryVariables
    >(GetStudentOnlineApplicationQuery, options);

    const studentOnlineApplication = useEntity(
        () =>
            new StudentOnlineApplicationEntity(
                queryResult.data?.getStudentOnlineApplication ?? null,
            ),
        [queryResult.data],
    );

    const result = {
        studentOnlineApplication,
        ...queryResult,
    };

    return result;
};

export { useStudentOnlineApplication };
